import { render, staticRenderFns } from "./PresentationVimeo.vue?vue&type=template&id=6fbff3f6&scoped=true&"
import script from "./PresentationVimeo.vue?vue&type=script&lang=js&"
export * from "./PresentationVimeo.vue?vue&type=script&lang=js&"
import style0 from "./PresentationVimeo.vue?vue&type=style&index=0&id=6fbff3f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbff3f6",
  null
  
)

export default component.exports